'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

// global object

//

var _partialsMediaGallery = require('partials/media-gallery');

var _partialsMediaGallery2 = _interopRequireDefault(_partialsMediaGallery);

var _partialsFilesGallery = require('../partials/files-gallery');

var _partialsFilesGallery2 = _interopRequireDefault(_partialsFilesGallery);

var _partialsExpandableMenu = require('partials/expandable-menu');

var _partialsExpandableMenu2 = _interopRequireDefault(_partialsExpandableMenu);

var _partialsMainnav = require('partials/mainnav');

var _partialsMainnav2 = _interopRequireDefault(_partialsMainnav);

var _partialsContact = require('partials/contact');

var _partialsContact2 = _interopRequireDefault(_partialsContact);

var _partialsGeoloc = require('partials/geoloc');

var _partialsGeoloc2 = _interopRequireDefault(_partialsGeoloc);

var _partialsLightbox = require('partials/lightbox');

var _partialsLightbox2 = _interopRequireDefault(_partialsLightbox);

var _partialsListPagination = require('partials/list-pagination');

var _partialsListPagination2 = _interopRequireDefault(_partialsListPagination);

var _partialsScrollWatcher = require('partials/scroll-watcher');

var _partialsScrollWatcher2 = _interopRequireDefault(_partialsScrollWatcher);

var _partialsSearch = require('partials/search');

var _partialsSearch2 = _interopRequireDefault(_partialsSearch);

var _partialsShare = require('partials/share');

var _partialsShare2 = _interopRequireDefault(_partialsShare);

var _partialsSwiper = require('partials/swiper');

var _partialsSwiper2 = _interopRequireDefault(_partialsSwiper);

var _partialsLoader = require('partials/loader');

var _partialsLoader2 = _interopRequireDefault(_partialsLoader);

// import parallax from '../partials/parallax';

var _partialsTransition = require('../partials/transition');

var _partialsTransition2 = _interopRequireDefault(_partialsTransition);

//import CustomCursor from "../partials/custom-cursor";

//VIEWS name = tpl name

var _viewsB4s3_home = require('views/b4s3_home');

var _viewsB4s3_home2 = _interopRequireDefault(_viewsB4s3_home);

window.G = window.G || {};
G._html = document.querySelector('html');
G.isMobile = (0, _domClasslist2['default'])(G._html).contains('mobile');
G.isTablet = (0, _domClasslist2['default'])(G._html).contains('tablet');
G.views = {};
G.views.b4s3_home = _viewsB4s3_home2['default'];

//
var _body = document.querySelector('body');

document.addEventListener("DOMContentLoaded", function () {
	_pubsub2['default'].emit('document:ready');
});

_pubsub2['default'].on('body:noscroll', function () {
	(0, _domClasslist2['default'])(_body).add('no-scroll');
});
_pubsub2['default'].on('body:scroll', function () {
	(0, _domClasslist2['default'])(_body).remove('no-scroll');
});

// Global resize
var resize = function resize() {
	_pubsub2['default'].emit('resize', window.innerWidth, window.innerHeight);
};
// Only native resize listener on site
window.addEventListener('resize', resize, false);
// Can be forced from any
_pubsub2['default'].on('global-resize', resize);

var initView = function initView() {
	var tpl = _body.getAttribute('data-view');
	if (G.views[tpl]) G.views[tpl]();
};

var initOnce = function initOnce() {
	//CustomCursor();
	(0, _partialsMainnav2['default'])();
	(0, _partialsLightbox2['default'])();
	(0, _partialsScrollWatcher2['default'])();
	(0, _partialsSearch2['default'])();

	var _expMenus = document.querySelectorAll('.expandable-menu');
	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = _expMenus[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var el = _step.value;

			(0, _partialsExpandableMenu2['default'])(el);
		}
		// parallax();
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator['return']) {
				_iterator['return']();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}
};

var recursiveInit = function recursiveInit() {

	(0, _partialsMediaGallery2['default'])();
	(0, _partialsFilesGallery2['default'])();
	(0, _partialsContact2['default'])();
	(0, _partialsGeoloc2['default'])();
	(0, _partialsListPagination2['default'])();
	(0, _partialsSwiper2['default'])();
	(0, _partialsTransition2['default'])();
	(0, _partialsLoader2['default'])();
};

_pubsub2['default'].on('document:ready', function () {
	initOnce();
	recursiveInit();
	initView();
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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